import React from 'react';
import { ResetPasswordPage } from 'lapki'; // eslint-disable-line import/no-extraneous-dependencies

import CenteredPaper from '../../layouts/CenteredPaperLayout';

export default props => <ResetPasswordPage Layout={CenteredPaper} />;
